import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-27f89967"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { id: "pdf" }, null, -1); });
var _hoisted_4 = [
    _hoisted_3
];
var _hoisted_5 = { class: "overlay-wrapper" };
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReviewReport',
    setup: function (__props) {
        var route = useRoute();
        var router = useRouter();
        var loadingVisible = ref(true);
        var pdfh5 = ref();
        onMounted(function () {
            pdfh5.value = new Pdfh5("#pdf", {
                pdfurl: route.query.reportUrl,
                // lazy: true,
                cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/",
            });
            pdfh5.value.on("complete", function () {
                console.log("加载完成");
                loadingVisible.value = false;
            });
        });
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "样本报告详情",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
                    [_vShow, !loadingVisible.value]
                ]),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
